import { render, staticRenderFns } from "./uploadPicture.vue?vue&type=template&id=f25f48e2&scoped=true"
import script from "./uploadPicture.vue?vue&type=script&lang=js"
export * from "./uploadPicture.vue?vue&type=script&lang=js"
import style0 from "./uploadPicture.vue?vue&type=style&index=0&id=f25f48e2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25f48e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mer_plat_admin_Qh4W/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f25f48e2')) {
      api.createRecord('f25f48e2', component.options)
    } else {
      api.reload('f25f48e2', component.options)
    }
    module.hot.accept("./uploadPicture.vue?vue&type=template&id=f25f48e2&scoped=true", function () {
      api.rerender('f25f48e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/uploadPicture.vue"
export default component.exports